import { Checkbox, Input } from "antd"
import Modal from "antd/es/modal/Modal"
import '../styles.scss'
import { ICustomerTypes } from "../../../api/selectOption/selectOptionsApi"
import { useEffect, useState } from "react"
interface ModalProp {
  isOpen: boolean
  dataFiler: ICustomerTypes[]
  selectedValues: (string | number)[]
  columnCode: string

  closeModal: (isClose: boolean) => void
  handleFilterColumnSelectChange: (columnCode: string, value: (string | number)[]) => void,
  handleSearch: (search?: string) => void

}
export const ModalFilterTypeCustomer: React.FC<ModalProp> = ({
  isOpen, dataFiler, selectedValues, columnCode,
  closeModal,
  handleFilterColumnSelectChange,
  handleSearch
}) => {

  const [selectedValueTmp, setSelectedValueTmp] = useState<(string | number)[]>([])

  const handleConfirm = () => {

    handleFilterColumnSelectChange(columnCode, selectedValueTmp)
    closeModal(false)
  }
  useEffect(() => {
    if (isOpen) {
      setSelectedValueTmp(selectedValues)
    } else {
      setSelectedValueTmp([])
    }
  }, [isOpen])

  return (
    <Modal
      open={isOpen}
      title={false}
      footer={false}
      closeIcon={false}
      onCancel={() => closeModal(false)}
      className="w-modal-242"
    >
      <div className={`d-flex flex-column shadow-dropdown-fliter`}>
        <div className="p-1">
          <Input
            placeholder="Tìm kiếm "
            onChange={(e) => handleSearch(e.target.value)}
            onClear={() => handleSearch(undefined)}
            allowClear
          />
        </div>
        <div className={`d-flex flex-column gap-2 pl-4 py-3  ${dataFiler?.length >= 7 ? "h-230-px overflow-y-scroll" : ""}`}>
          {
            dataFiler?.map((item, i) => (
              <Checkbox
                key={i}
                checked={selectedValueTmp?.includes(item.id)}
                onChange={(e) => {
                  const checked = e.target.checked;
                  const newValue = item.id;
                  if (checked) {
                    setSelectedValueTmp(prev => [...prev, newValue]);
                  } else {
                    setSelectedValueTmp(prev => prev.filter(id => id !== newValue));
                  }
                }}
                className="size-check-box size-check-box-inner p-checkbox icon-check-box">
                <p key={i} className={`bg-${item.backgroundColor}  rounded-2 text-${item.color} text-xs px-2 d-flex align-center gap-3-px h-22-px font-regular w-fit`}>
                  {item.code}
                </p>
              </Checkbox>

            ))
          }
        </div>
        <div className='d-flex justify-between p-2 border-t-F0F0F0'>
          <button
            // disabled={!isAnyChecked}
            // onClick={reSetAllChecked}
            onClick={() => setSelectedValueTmp([])}
            className={`${selectedValueTmp?.length ? 'text-c40d0d' : 'text-BFBFBF'} border-none bg-white text-sm font-regular `} >
            Làm mới
          </button>
          <button
            // onClick={() => setFilterVisible(false)}
            onClick={handleConfirm}
            className='border-none bg-096DD9 text-sm rounded-2 h-8 px-7-px font-regular text-white'>
            Xác nhận
          </button>
        </div>
      </div>

    </Modal>

  )
}
